import * as yup from 'yup'
import { IntlShape } from 'react-intl'

export interface Values {
  email: string
}

export const schema = {
  email: ''
}

export const validation = (deps: { intl: IntlShape }) => {
  const { formatMessage } = deps.intl

  return (
    yup
      .object()
      .shape({
        email: yup
          .string()
          .email(formatMessage({ id: 'validation.emailValid' }))
          .required(formatMessage({ id: 'validation.emailValid' }))
      })
  )
}
